
document.addEventListener('DOMContentLoaded', () => {

  const header = document.querySelector('.luxury-header');
  const headerWrapper = document.querySelector('.luxury-header-wrapper');

  if (header && headerWrapper) {

    let headerHeight = header.offsetHeight;
    let isSticky = false;

    const handleHeaderScroll = () => {

      if (window.scrollY > 0 && !isSticky) {
        header.style.position = 'fixed';
        header.style.top = '0';
        header.style.left = '0';
        header.style.right = '0';
        header.style.zIndex = '95';
        header.classList.add('scrolled');
        headerWrapper.style.paddingTop = headerHeight + 'px';
        isSticky = true;

      } else if (window.scrollY <= 0 && isSticky) {
        header.style.position = '';
        header.style.top = '';
        header.style.left = '';
        header.style.right = '';
        header.style.zIndex = '';
        header.classList.remove('scrolled');
        headerWrapper.style.paddingTop = '';
        isSticky = false;
      }

    };

    handleHeaderScroll();

    window.addEventListener('scroll', handleHeaderScroll, {
      passive: true
    });

    // Recalculate height on resize
    window.addEventListener('resize', () => {
      headerHeight = header.offsetHeight;
      if (isSticky) {
        headerWrapper.style.paddingTop = headerHeight + 'px';
      }
    });

  }

  /* ==========================================================
     ANNOUNCEMENT SLIDER
     ========================================================== */

  const slider = document.querySelector('.luxury-announcement-slider');

  if (slider) {

    const slides = slider.querySelectorAll('.luxury-slide');
    const nextBtn = document.querySelector('.luxury-next');
    const prevBtn = document.querySelector('.luxury-prev');

    if (slides.length > 1) {

      let current = 0;
      let autoplay;

      slides.forEach((slide, index) => {

        slide.style.display =
          index === 0 ? 'block' : 'none';

      });

      const showSlide = (index) => {

        slides.forEach((slide) => {

          slide.style.display = 'none';
          slide.style.opacity = '0';

        });

        slides[index].style.display = 'block';

        requestAnimationFrame(() => {
          slides[index].style.opacity = '1';
        });

      };

      const nextSlide = () => {

        current++;

        if (current >= slides.length) {
          current = 0;
        }

        showSlide(current);

      };

      const prevSlide = () => {

        current--;

        if (current < 0) {
          current = slides.length - 1;
        }

        showSlide(current);

      };

      const startAutoplay = () => {

        autoplay = setInterval(() => {
          nextSlide();
        }, 5000);

      };

      const stopAutoplay = () => {

        clearInterval(autoplay);

      };

      nextBtn?.addEventListener('click', () => {

        stopAutoplay();
        nextSlide();
        startAutoplay();

      });

      prevBtn?.addEventListener('click', () => {

        stopAutoplay();
        prevSlide();
        startAutoplay();

      });

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);

      startAutoplay();

    }

  }

  /* ==========================================================
     SEARCH PANEL
     ========================================================== */

  const searchBtns = document.querySelectorAll('.luxury-search-btn');
  const searchPanel = document.querySelector('.luxury-search-panel');
  const searchClose = document.querySelector('.luxury-search-panel__close');
  const searchInput = searchPanel?.querySelector('input[type="search"]');

  const openSearch = () => {

    if (!searchPanel) return;

    searchPanel.classList.add('active');
    searchBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));

    window.requestAnimationFrame(() => {
      searchInput?.focus();
    });

  };

  const closeSearch = () => {

    searchPanel?.classList.remove('active');
    searchBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));

    const results = searchPanel?.querySelector('[data-search-results]');
    results?.classList.remove('active');

  };

  const toggleSearch = () => {

    if (!searchPanel) return;

    if (searchPanel.classList.contains('active')) {
      closeSearch();
    } else {
      openSearch();
    }

  };

  searchBtns.forEach((btn) => {
    btn.addEventListener('click', (event) => {

      event.preventDefault();
      event.stopPropagation();
      toggleSearch();

    });
  });

  searchClose?.addEventListener('click', closeSearch);

  document.addEventListener('click', (event) => {

    if (
      searchPanel &&
      searchPanel.classList.contains('active') &&
      !event.target.closest('.luxury-search-panel') &&
      !event.target.closest('.luxury-search-btn')
    ) {
      closeSearch();
    }

  });

  /* ==========================================================
     SEARCH SUGGESTIONS (PREDICTIVE SEARCH)
     ========================================================== */

  const resultsBox = searchPanel?.querySelector('[data-search-results]');

  if (searchInput && resultsBox) {

    let debounceTimer;
    let currentController;

    const escapeHtml = (str) =>
      String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    const renderResults = (data, query) => {

      const products = data?.resources?.results?.products || [];
      const collections = data?.resources?.results?.collections || [];
      const queries = data?.resources?.results?.queries || [];

      if (!products.length && !collections.length && !queries.length) {

        resultsBox.innerHTML =
          `<div class="luxury-search-empty">No results for &ldquo;${escapeHtml(query)}&rdquo;</div>`;

        resultsBox.classList.add('active');
        searchInput.setAttribute('aria-expanded', 'true');

        return;

      }

      let html = '';

      if (queries.length) {

        html += '<div class="luxury-search-group"><span class="luxury-search-group-label">Suggestions</span><ul class="luxury-search-suggestion-list">';

        queries.slice(0, 5).forEach((item) => {
          html += `<li><a href="${item.url}" class="luxury-search-suggestion">${item.styled_text || escapeHtml(item.text)}</a></li>`;
        });

        html += '</ul></div>';

      }

      if (collections.length) {

        html += '<div class="luxury-search-group"><span class="luxury-search-group-label">Collections</span><ul class="luxury-search-suggestion-list">';

        collections.slice(0, 4).forEach((item) => {
          html += `<li><a href="${item.url}" class="luxury-search-suggestion">${escapeHtml(item.title)}</a></li>`;
        });

        html += '</ul></div>';

      }

      if (products.length) {

        html += '<div class="luxury-search-group"><span class="luxury-search-group-label">Products</span><ul class="luxury-search-product-list">';

        products.slice(0, 6).forEach((item) => {

          const image = item.featured_image?.url || item.image || '';

          html += `
            <li>
              <a href="${item.url}" class="luxury-search-product">
                ${image ? `<span class="luxury-search-product-image"><img src="${image}" alt="${escapeHtml(item.title)}" loading="lazy"></span>` : ''}
                <span class="luxury-search-product-info">
                  <span class="luxury-search-product-title">${escapeHtml(item.title)}</span>
                  <span class="luxury-search-product-price">${item.price || ''}</span>
                </span>
              </a>
            </li>
          `;

        });

        html += '</ul></div>';

      }

      resultsBox.innerHTML = html;
      resultsBox.classList.add('active');
      searchInput.setAttribute('aria-expanded', 'true');

    };

    const fetchSuggestions = (query) => {

      if (currentController) {
        currentController.abort();
      }

      currentController = new AbortController();

      const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,query&resources[limit]=10&resources[options][unavailable_products]=last`;

      fetch(url, { signal: currentController.signal })
        .then((res) => res.json())
        .then((data) => renderResults(data, query))
        .catch((err) => {
          if (err.name !== 'AbortError') {
            resultsBox.classList.remove('active');
          }
        });

    };

    searchInput.addEventListener('input', (event) => {

      const query = event.target.value.trim();

      clearTimeout(debounceTimer);

      if (query.length < 2) {
        resultsBox.classList.remove('active');
        resultsBox.innerHTML = '';
        searchInput.setAttribute('aria-expanded', 'false');
        return;
      }

      debounceTimer = setTimeout(() => {
        fetchSuggestions(query);
      }, 300);

    });

    searchInput.addEventListener('focus', () => {

      if (resultsBox.innerHTML.trim() !== '' && searchInput.value.trim().length >= 2) {
        resultsBox.classList.add('active');
      }

    });

  }

    /* ==========================================================
     CART ICON -> OPEN CART DRAWER (instead of /cart page)
     ========================================================== */

  const cartDrawerEl = document.querySelector('cart-drawer');

  if (cartDrawerEl) {
    document
      .querySelectorAll('.luxury-cart-btn, .luxury-mobile-cart')
      .forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();

          // mobile drawer khula ho to band karo
          document.querySelector('.luxury-mobile-menu')?.classList.remove('active');
          document.querySelector('.luxury-mobile-overlay')?.classList.remove('active');

          if (typeof cartDrawerEl.open === 'function') {
            cartDrawerEl.open();
          } else {
            cartDrawerEl.classList.add('animate', 'active');
            document.body.classList.add('overflow-hidden');
          }
        });
      });
  }

  /* ==========================================================
     MOBILE DRAWER
     ========================================================== */

  const drawer = document.querySelector('.luxury-mobile-menu');
  const overlay = document.querySelector('.luxury-mobile-overlay');

  const openBtn =
    document.querySelector('.luxury-hamburger');

  const closeBtn =
    document.querySelector('.luxury-mobile-close');

  /* ==========================================================
     WISHLIST PLACEHOLDER GUARD
     ========================================================== */

  document
    .querySelectorAll('[data-wishlist-placeholder="true"]')
    .forEach((link) => {

      link.addEventListener('click', (event) => {

        event.preventDefault();

        console.warn(
          'Luxury Header: no Wishlist Page URL is set in theme settings, so the wishlist link is disabled. Set one under Header Icons > Wishlist Page URL.'
        );

      });

    });

  const openDrawer = () => {

    if (!drawer) return;

    drawer.classList.add('active');

    overlay?.classList.add('active');

    document.body.classList.add('overflow-hidden');

  };

  const closeDrawer = () => {

    drawer?.classList.remove('active');

    overlay?.classList.remove('active');

    document.body.classList.remove('overflow-hidden');

  };

  openBtn?.addEventListener('click', openDrawer);

  closeBtn?.addEventListener('click', closeDrawer);

  overlay?.addEventListener('click', closeDrawer);

  /* ==========================================================
     ESCAPE KEY SUPPORT
     ========================================================== */

  document.addEventListener('keydown', (event) => {

    if (event.key === 'Escape') {
      closeDrawer();
      closeSearch();
    }

  });

  /* ==========================================================
     FOCUS TRAP
     ========================================================== */

  if (drawer) {

    drawer.addEventListener('keydown', (event) => {

      if (event.key !== 'Tab') return;

      const focusable = drawer.querySelectorAll(
        'a, button, input, select, textarea'
      );

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {

        event.preventDefault();
        last.focus();

      }

      if (
        !event.shiftKey &&
        document.activeElement === last
      ) {

        event.preventDefault();
        first.focus();

      }

    });

  }

  /* ==========================================================
     MEGA MENU - FIXED HOVER HANDLING
     ========================================================== */

  const megaMenuItems = document.querySelectorAll('.has-mega-menu');
  let megaMenuHideTimeout;

  megaMenuItems.forEach((item) => {

    const megaMenu = item.querySelector('.luxury-mega-menu');

    if (!megaMenu) return;

    const openMegaMenu = () => {
      clearTimeout(megaMenuHideTimeout);
      item.classList.add('mega-open');
    };

    const closeMegaMenu = () => {
      megaMenuHideTimeout = setTimeout(() => {
        item.classList.remove('mega-open');
      }, 200); // 200ms delay before hiding
    };

    // Open on menu item hover
    item.addEventListener('mouseenter', openMegaMenu);
    item.addEventListener('mouseleave', closeMegaMenu);

    // Open on mega menu hover
    megaMenu.addEventListener('mouseenter', openMegaMenu);
    megaMenu.addEventListener('mouseleave', closeMegaMenu);

  });

  /* ==========================================================
     MEGA MENU CATEGORY SWITCHING
     ========================================================== */

  const categoryItems =
    document.querySelectorAll('.luxury-category-item');

  const panels =
    document.querySelectorAll('.luxury-submenu-panel');

  if (
    categoryItems.length &&
    panels.length
  ) {

    categoryItems.forEach((item) => {

      item.addEventListener('mouseenter', () => {

        const target =
          item.dataset.category;

        categoryItems.forEach((el) => {

          el.classList.remove('is-active');

        });

        panels.forEach((panel) => {

          panel.classList.remove('active');

        });

        item.classList.add('is-active');

        document
          .querySelector(
            `.luxury-submenu-panel[data-panel="${target}"]`
          )
          ?.classList.add('active');

      });

    });

  }

  /* ==========================================================
     TOUCH SUPPORT
     ========================================================== */

  if ('ontouchstart' in window) {

    document
      .querySelectorAll('.has-mega-menu')
      .forEach((item) => {

        const trigger =
          item.querySelector('.luxury-nav-link');

        trigger?.addEventListener('click', (event) => {

          if (
            window.innerWidth > 989 &&
            !item.classList.contains('touch-open')
          ) {

            event.preventDefault();

            document
              .querySelectorAll('.has-mega-menu')
              .forEach((el) => {

                el.classList.remove('touch-open');

              });

            item.classList.add('touch-open');

          }

        });

      });

    document.addEventListener('click', (event) => {

      if (
        !event.target.closest('.has-mega-menu')
      ) {

        document
          .querySelectorAll('.has-mega-menu')
          .forEach((el) => {

            el.classList.remove('touch-open');

          });

      }

    });

  }

  /* ==========================================================
     COLLECTION CARD REVEAL
     ========================================================== */

  const cards =
    document.querySelectorAll(
      '.luxury-collection-card'
    );

  if ('IntersectionObserver' in window) {

    const observer =
      new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {

            entry.target.classList.add('revealed');

            observer.unobserve(entry.target);

          }

        });

      }, {
        threshold: 0.15
      });

    cards.forEach((card) => {

      observer.observe(card);

    });

  }

  /* ==========================================================
     BUTTON RIPPLE EFFECT
     ========================================================== */

  document
    .querySelectorAll(
      '.luxury-action-btn, .luxury-promo-button, #wishlist-icon-bubble'
    )
    .forEach((button) => {

      button.addEventListener('click', (event) => {

        const ripple =
          document.createElement('span');

        ripple.className = 'luxury-ripple';

        const rect =
          button.getBoundingClientRect();

        ripple.style.left =
          event.clientX - rect.left + 'px';

        ripple.style.top =
          event.clientY - rect.top + 'px';

        button.appendChild(ripple);

        setTimeout(() => {
          ripple.remove();
        }, 600);

      });

    });

  /* ==========================================================
     RESIZE HANDLER
     ========================================================== */

  let resizeTimer;

  window.addEventListener('resize', () => {

    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {

      if (window.innerWidth > 989) {
        closeDrawer();
      }

    }, 200);

  });

});
